export default function PHP_Traits() {
  return (
    <div>
      <h1>PHP_Traits</h1>
    </div>
  );
}
